module.exports = __webpack_public_path__ + "static/media/projectPic9.2f1766dc.png";